import MUIFonts from './MUIFonts';

const MuiButton = {
  styleOverrides: {
    root: {
      textTransform: 'none' as const,
      maxHeight: '36.5px',
      '& .MuiButton-textSizeSmall': {
        ...MUIFonts.buttonSmall,
      },
      '& .MuiButton-textSizeMedium': {
        ...MUIFonts.buttonMedium,
      },
      '& .MuiButton-textSizeLarge': {
        ...MUIFonts.buttonLarge,
      },
    },
  },
};

export default MuiButton;
